// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9312) return "static/chunks/9312-f0ad064e3eded256.js";
	if (chunkId === 9579) return "static/chunks/9579-1ff19e18347e34a3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"806":"9d0403e1bf4c60a5","1354":"28f17dd07a567245","2480":"2dc8c88f57ce68e9","2718":"144f2739e371027f","5362":"0501da5bc72472a6","5647":"7e3a7e85a78fa679","9877":"b3213eb2eebcb2ed"}[chunkId] + ".js";
};